<template>
  <div id="SectionTrust">
    <UIContainer class="SectionTrust__container">
      <p class="SectionTrust__statement">
        Trusted by forward thinking businesses
      </p>

      <div
        class="SectionTrust__marquee-container"
        style="--fade-left-size: 96px; --fade-right-size: 96px"
      >
        <div class="SectionTrust__marquee">
          <div
            v-for="(logo, index) in [
              ...partnerLogos,
              ...partnerLogos,
              ...partnerLogos,
            ]"
            :key="index"
            class="SectionTrust__logo"
          >
            <img
              :src="logo.src"
              :alt="logo.name"
              class="SectionTrust__logo-image"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'

// Define partner logos with their paths
const partnerLogos = ref([
  {
    name: 'Aros Marine',
    src: '/images/partnerLogos/aros-marine.avif',
  },
  {
    name: 'Bite Lietuva',
    src: '/images/partnerLogos/bite.avif',
  },
  {
    name: 'Hegelmann Group',
    src: '/images/partnerLogos/hegelmann.avif',
  },
  {
    name: 'Passer',
    src: '/images/partnerLogos/passer.avif',
  },
  {
    name: 'PST',
    src: '/images/partnerLogos/pst.avif',
  },
  {
    name: 'Agrokoncernas',
    src: '/images/partnerLogos/agrokoncernas.avif',
  },
  {
    name: 'Kormotech',
    src: '/images/partnerLogos/kormotech.avif',
  },
  {
    name: 'Rokiškio sūris',
    src: '/images/partnerLogos/rokiskiosuris.avif',
  },
])
</script>

<style lang="scss" scoped>
#SectionTrust {
  .SectionTrust__container {
    padding: 2rem 0 2rem;

    @include md {
      padding: 2.5rem 0 6rem;
    }
  }

  .SectionTrust__statement {
    @include font-size-18px();
    color: $color-ui-gray-cool-600;
    font-weight: 600;
    margin-bottom: 2rem;
    text-align: center;
  }

  .SectionTrust__marquee-container {
    overflow: hidden;
    margin-top: 1.5rem;
    width: 100%;
    position: relative;
    // Mask-based edge fades that reveal parent background
    --fade-left-size: 0px;
    --fade-right-size: 0px;
    -webkit-mask-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0,
      rgba(0, 0, 0, 1) var(--fade-left-size),
      rgba(0, 0, 0, 1) calc(100% - var(--fade-right-size)),
      rgba(0, 0, 0, 0) 100%
    );
    mask-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0,
      rgba(0, 0, 0, 1) var(--fade-left-size),
      rgba(0, 0, 0, 1) calc(100% - var(--fade-right-size)),
      rgba(0, 0, 0, 0) 100%
    );
  }

  .SectionTrust__marquee {
    display: flex;
    align-items: center;
    gap: 2rem;
    white-space: nowrap;
    animation: scroll-left 20s linear infinite;
    width: fit-content;

    @include md {
      gap: 3rem;
    }

    &:hover {
      animation-play-state: paused;
    }
  }

  @keyframes scroll-left {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-35%);
    }
  }

  .SectionTrust__logo {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.3s ease;
    margin-right: 2rem;

    @include md {
      margin-right: 3rem;
    }
  }

  .SectionTrust__logo-image {
    width: auto;
    height: auto;
    object-fit: contain;
    max-height: 48px;
  }
}
</style>
